import React from 'react';
type SunRaysProps = {
  className?: string;
};
const RAYS = Array.from({
  length: 28
}, (_, i) => i * 360 / 28);
export function SunRays({
  className = ''
}: SunRaysProps) {
  return <svg viewBox="0 0 400 400" className={className} aria-hidden="true" data-id="element-59" data-mp="366mfm3v4st4o">
      {RAYS.map((deg, i) => <line key={deg} x1="200" y1="200" x2="200" y2={i % 2 === 0 ? 8 : 48} stroke="currentColor" strokeWidth={i % 2 === 0 ? 3 : 2} strokeLinecap="round" transform={`rotate(${deg} 200 200)`} data-id="element-60" data-mp="3axl0lgr2efe9" data-mpi={i} />)}
    </svg>;
}